import React, { useState } from "react";

export default function ProjectAccordion({
    id,
    summary,
    open: openProp,
    onToggle,
    defaultOpen = false,
    children,
    onChecked,
    isChecked,
    actionButton = null
}) {
    // controlled if `open` prop provided, otherwise internal state
    const [openState, setOpenState] = useState(Boolean(defaultOpen));
    const controlled = typeof openProp === "boolean";
    const open = controlled ? openProp : openState;

    const toggle = () => {
        const next = !open;
        if (controlled) {
            if (typeof onToggle === "function") onToggle(next);
        } else {
            setOpenState(next);
            if (typeof onToggle === "function") onToggle(next);
        }
    };

    return (
        <div className={`project-accordion ${open ? "open" : ""}`}>
            <button
                type="button"
                className="project-accordion-summary"
                aria-expanded={open}
                aria-controls={id}
                onClick={toggle}
            >
                <div className="project-accordion-title">
                    {/* <Checkbox onClick={onChecked} checked={isChecked} color="primary" /> */}
                    <span className="summary-content">{summary}</span>
                </div>
                {actionButton}
                <span className="summary-icon" aria-hidden>{open ? "▾" : "▸"}</span>
            </button>

            <div id={id} className="project-accordion-details" role="region" hidden={!open}>
                {children}
            </div>
        </div>
    );
}